import { useTranslation } from 'react-i18next';
import { Fieldset, Radio, ValidationMessage } from '@digdir/designsystemet-react';

import { useOppvarmingFormContext } from '../../../../utils';
import { JaNeiVetIkke } from '../../../../../../../../../components/registering/utils/registerEnums';


//This component is currently the inverse of what the name says.
//It asks whether the heating central is NOT installed in a heated room.
//Therefore are labels and values inverted. Fix in january 2025 when the component.
// TODO: US18027

export const InstallertIOppvarmetRomRadio = () => {
  const { t } = useTranslation();
  const { register, formState } = useOppvarmingFormContext();

  const error = formState.errors.elektrisk?.value?.varmtvannsbereder?.value?.installertIOppvarmetRom;

  return (
    <Fieldset>
      <Fieldset.Legend>
        {t('form.oppvarming.elektrisitet.varmtvannsbereder.installertIOppvarmetRom.label')}
      </Fieldset.Legend>
      <Radio
        {...register('elektrisk.value.varmtvannsbereder.value.installertIOppvarmetRom', {
          required: t('form.oppvarming.elektrisitet.varmtvannsbereder.installertIOppvarmetRom.error'),
          shouldUnregister: true
        })}
        label={t('form.common.yes')}
        value={JaNeiVetIkke.Nei}
        aria-invalid={!!error}
      />
      <Radio
        {...register('elektrisk.value.varmtvannsbereder.value.installertIOppvarmetRom', {
          required: t('form.oppvarming.elektrisitet.varmtvannsbereder.installertIOppvarmetRom.error'),
          shouldUnregister: true
        })}
        label={t('form.common.no')}
        value={JaNeiVetIkke.Ja}
        aria-invalid={!!error}
      />

      {!!error?.message && <ValidationMessage data-color="danger">{error.message}</ValidationMessage>}
    </Fieldset>
  );
};
